var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgSadInbox = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 95 79"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-763 -200)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M856 237l-14-34a6 6 0 00-3-2 6 6 0 00-3-1h-51a6 6 0 00-3 1 6 6 0 00-3 2l-14 34a20 20 0 00-2 8v30a4 4 0 001 3 4 4 0 003 1h87a4 4 0 004-4v-30a20 20 0 00-2-8zm-30 6l-6 12h-19l-6-12h-20a3 3 0 010-1l14-31h43l14 31v1z",
  fill: "#d5dee5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  transform: "translate(800 224)",
  fill: "#d5dee5",
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  transform: "translate(816 224)",
  fill: "#d5dee5",
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M807 236s4-5 9 0",
  fill: "none",
  stroke: "#d5dee5",
  strokeLinecap: "round",
  strokeWidth: 3
}))));

export default SvgSadInbox;